<template>
  <div
    class="carousel-container"
    :style="{
      width: `${styles.width}`.includes('%')
        ? styles.width
        : styles.width + 'px',
      ...(styles.height && {height: styles.height + 72 + 'px'}),
    }"
    :class="[{fullSreen}]"
    @click.self="requestFullScreen"
  >
    <div
      class="carousel"
      :style="{
        width: `${styles.width}`.includes('%')
          ? styles.width
          : styles.width + 'px',
        ...(styles.height && {height: styles.height + 72 + 'px'}),
      }"
    >
      <div
        class="slide"
        :style="{backgroundImage: `url(${slides[currentSlide]})`}"
        @click.self="requestFullScreen"
      />
    </div>
    <div v-if="images.length > 1" class="actions">
      <div class="buttons" :class="{buttons_reverse: right}">
        <div @click="prev">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29"
            height="28"
            viewBox="0 0 29 28"
            fill="none"
            :class="{disable: !currentSlide}"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.9368 8.20143L10.381 13.5045C10.0952 13.7772 10.0952 14.2228 10.381 14.4955L15.9368 19.7986C16.2182 20.0671 16.6713 20.0671 16.9527 19.7986C17.2384 19.5258 17.2384 19.0802 16.9527 18.8075L11.916 14L16.9527 9.19251C17.2384 8.91976 17.2384 8.47418 16.9527 8.20143C16.6713 7.93286 16.2182 7.93286 15.9368 8.20143Z"
            />
          </svg>
        </div>
        <div class="currentSlide">
          <span>{{ currentSlide + 1 }}</span> / {{ slides.length }}
        </div>
        <div @click="next">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29"
            height="28"
            viewBox="0 0 29 28"
            fill="none"
            :class="{disable: currentSlide === images.length - 1}"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.0641 19.7986L18.6197 14.4955C18.9054 14.2228 18.9054 13.7772 18.6197 13.5045L13.0641 8.20143C12.7828 7.93286 12.3297 7.93286 12.0483 8.20143C11.7625 8.47418 11.7625 8.91976 12.0483 9.19251L17.0847 14L12.0483 18.8075C11.7625 19.0802 11.7625 19.5258 12.0483 19.7986C12.3297 20.0671 12.7828 20.0671 13.0641 19.7986Z"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, ref} from 'vue';
import type {PropType} from 'vue';
import {useDirectionStore} from '~/store/direction.store';

export default defineComponent({
  name: 'CustomSlider',
  props: {
    images: {
      type: Array as PropType<string[]>,
      required: true,
    },
    width: {
      type: Number || String,
      required: false,
      default: 744,
    },
    height: {
      type: Number,
      required: false,
      default: 419,
    },
  },

  setup(props) {
    const direction = useDirectionStore();
    const right = computed(() => direction.$state.isRight);
    const slides = ref(props.images);
    const styles = ref({
      width: props.width,
      height: props.height,
    });
    const currentSlide = ref(0);
    const elem = ref(undefined);
    const fullSreen = ref(false);
    const next = () => {
      currentSlide.value += 1;
      if (currentSlide.value >= slides.value.length) {
        currentSlide.value = 0;
      }
    };
    const prev = () => {
      currentSlide.value -= 1;
      if (currentSlide.value < 0) {
        currentSlide.value = slides.value.length - 1;
      }
    };
    function requestFullScreen() {
      fullSreen.value = !fullSreen.value;
      if (fullSreen.value) {
        styles.value.width = `${styles.value.width}`.includes('%')
          ? `90%`
          : styles.value.width * 1.5;
        styles.value.height = styles.value.height * 1.5;
      } else {
        styles.value = {
          width: props.width,
          height: props.height,
        };
      }
    }
    return {
      next,
      prev,
      requestFullScreen,
      fullSreen,
      slides,
      styles,
      currentSlide,
      elem,
      right,
    };
  },
});
</script>

<style lang="scss" scoped>
.carousel-container {
  user-select: none;
  .carousel {
    .slide {
      height: 419px;
      width: 100%;
      background-repeat: no-repeat;
      background-position: center;
      transition: all 0.3s ease;
      border-radius: 16px;
      background-size: cover;

      @media (max-width: $md) {
        background-size: contain;
        height: 300px;
      }
      @media (max-width: 400px) {
        background-size: contain;
        height: 250px;
      }
    }
  }
  &.fullSreen {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    width: 100% !important;
    height: 100% !important;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(68, 68, 68, 0.75);
    //backdrop-filter: blur(4px);
    z-index: 9999;
    .actions {
      width: 100%;
    }
    .slide {
      background-size: contain;
    }
  }
  .actions {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .buttons {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #ffffff;
    border: 2px solid #b2c0cd;
    border-radius: 8px;
    padding: 4px;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0.02em;
    color: #b2c0cd;
    margin-top: 16px;
    span {
      color: #3d424a;
    }
    svg {
      fill: #3d424a;
      display: block;
      cursor: pointer;
      &.disable {
        fill: #839aaf;
      }
    }

    &_reverse {
      svg {
        transform: rotate(180deg);
      }
    }
  }
}
</style>
